// extracted by mini-css-extract-plugin
module.exports = {"category_wrapper":"AppCategoryTagList_category_wrapper__y05ow"};